import identity from 'lodash/identity';
import isNil from 'lodash/isNil';

export function displayAddress(attributes = {}) {
  if (typeof attributes !== 'object') {
    throw new Error('displayAddress() must be invoked with an object');
  }

  const { streetAddress, city, state, postcode } = attributes;
  const addressStr = [streetAddress, city, state].filter(x => x).join(', ');

  return postcode ? `${addressStr} ${postcode}` : addressStr;
}

export function displayRange(lower, upper, options = {}) {
  const { format = identity, nilString = '', currencySymbol = '' } = options;

  const lowerStr = !isNil(lower) ? `${currencySymbol}${format(lower)}` : nilString;
  const upperStr = !isNil(upper) ? `${currencySymbol}${format(upper)}` : nilString;

  return lower === upper ? lowerStr : `${lowerStr} – ${upperStr}`;
}

// @example
// firstNameInitial('Brad Fitler') -> 'B. Fitler'
export function firstNameInitial(name) {
  const [firstName, ...restName] = name.split(' ');
  const lastName = restName.join(' ');
  return `${firstName[0]}. ${lastName}`;
}

// @example
// formatName('Brad Fitler', 15) -> 'Brad Fitler'
// formatName('Anthony Milford', 15) -> 'A. Milford'
export function formatName(name, characterLimit) {
  if (name && name.length > characterLimit) {
    return firstNameInitial(name);
  }
  return name;
}
